/**
 * Cross-platform Storage Utility
 * Works on both web (localStorage) and mobile (Capacitor Preferences)
 */

import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';
import logger from './logger';

const isNative = Capacitor.isNativePlatform();

logger.log(`📱 Storage initialized for: ${isNative ? 'Mobile (Capacitor Preferences)' : 'Web (localStorage)'}`);

export const storage = {
  async setItem(key, value) {
    if (isNative) {
      await Preferences.set({ key, value });
    } else {
      localStorage.setItem(key, value);
    }
  },

  async getItem(key) {
    if (isNative) {
      const { value } = await Preferences.get({ key });
      return value;
    } else {
      return localStorage.getItem(key);
    }
  },

  async removeItem(key) {
    if (isNative) {
      await Preferences.remove({ key });
    } else {
      localStorage.removeItem(key);
    }
  },

  async clear() {
    if (isNative) {
      await Preferences.clear();
    } else {
      localStorage.clear();
    }
  },

  async keys() {
    if (isNative) {
      const { keys } = await Preferences.keys();
      return keys;
    } else {
      return Object.keys(localStorage);
    }
  },
};

export default storage;
